import type { SVGProps } from 'react';

const SvgArrowSmallS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15.71 13.29a.996.996 0 0 0-1.41 0l-1.29 1.29V6.99c0-.55-.45-1-1-1s-1 .45-1 1v7.59l-1.29-1.29a.996.996 0 1 0-1.41 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29l3-3a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgArrowSmallS;
